import React, { Suspense, useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import {config} from '../config'
import logo from "../assets/images/logo.png";
import _axios from "../axios";
import { AccountContext } from "../contexts/AccountContext";
import buildLink, { path } from "../urls";
import Logo from "../assets/images/logo-red.png";
import LogofloOrange from "../assets/images/logo-flo-orange.png";
import logoflo from "../assets/images/logo-flo.png";
import TopWishlist from "./TopWishlist";
import Cookies from "js-cookie";
import HeaderNew from "./HeaderNew";
import TopAccount from "./TopAccount";
import { CurrencyContext } from "../contexts/CurrencyContext";
import ImageFilter from "react-image-filter/lib/ImageFilter";
import { AiFillSetting } from "react-icons/ai";
import DOMPurify from "dompurify";
import { ExportProductContext } from "../contexts/ExportProductContext";
import { HandleAuthForm } from "./HandleAuthForm";
import { FiChevronDown } from "react-icons/fi";
import useDeviceSize from "./useDeviceSize";
import TopAccountTest from "./TopAccountTest";
export function useWindowDimensions() {
  const hasWindow = typeof window !== "undefined";

  function getWindowDimensions() {
    const width = hasWindow ? window.innerWidth : null;
    const height = hasWindow ? window.innerHeight : null;
    return {
      width,
      height,
    };
  }
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    if (hasWindow) {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, [hasWindow]);
  return windowDimensions;
}

const TopSearch = React.lazy(() => import("./TopSearch"));
const TopCart = React.lazy(() => import("./TopCart"));
// const TopAccount = React.lazy(() => import("./TopAccount"));
const DesktopMenu = React.lazy(() => import("./DesktopMenu-test"));
export let admin;

function TopHeader() {
  const { openAuthForm } = HandleAuthForm();
  const [show, setshow] = useState(false);
  const [state, dispatch] = useContext(AccountContext);
  const { exportProduct, setExportProduct } = useContext(ExportProductContext);
  const { loadingExport, setLoadingExport } = useContext(ExportProductContext);
  const { errPermission, setErrPermission } = useContext(ExportProductContext);
  const currency = useContext(CurrencyContext);
  const [sellerId, setSellerId] = useState("0");
  const [showMessage, setShowMessage] = useState(false);
  const [token, setToken] = useState();
  const [local, setShowHide] = useState(false);
  const [headerSettings, setHeaderSettings] = useState([]);

const [width] = useDeviceSize();

  useEffect(() => {
    if (
      window.location.host === "localhost:3000" ||
      window.location.host === "localhost:3001"
    ) {
      setShowHide(true);

      // console.log(window.location.host)
    }
    if (localStorage.getItem("site-local-name") === "flo") {
    }
    function checkCookies() {
      const adminToken = Cookies.get("ATDetails");
      if (typeof adminToken != "undefined") {
        setToken(adminToken);
      }

      // }
    }
    checkCookies();
    // const numbers = ["71060215", "71715333", "70222099", "70306099"];
    // const numbers = currency?.data?.whatsapp_number  ;
    const numbers = window.config["numbers"];
    console.log(numbers);
    if (numbers?.length > 12) {
      const number = numbers[Math.floor(Math.random() * numbers?.length)];
      if (Cookies.get("wtspNumber") === undefined) {
        Cookies.set("wtspNumber", number, { expires: 1 });
        dispatch({ type: "setNumber", payload: number });
      } else {
        const oldNumber = Cookies.get("wtspNumber");
        dispatch({ type: "setNumber", payload: oldNumber });
      }
      if (Cookies.get("seller_id") !== "0") {
        setSellerId(Cookies.get("seller_id"));
      }
    } else {
      dispatch({ type: "setNumber", payload: currency?.data?.whatsapp_number });
    }
  }, [currency]);

  // useEffect(() => {
  //   // console.log(isShowHeader)
  //   _axios
  //     .get(
  //       buildLink("headerv2", undefined, undefined, window.location.host)
  //     )
  //     .then((response) => {
  //       // setState(response.data.data);
  //       setHeaderSettings(response.data.header_settings);
  //     });
  // }, []);

  const location = useLocation();
  const history = useNavigate();

  useEffect(() => {
    setViewMenu(false);
  }, [location]);

  const [viewMenu, setViewMenu] = useState(false);
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState({});
  const [viewLevel2, setViewLevel2] = useState(false);
  const [int, setInt] = useState(false);
  const [curr, setCurr] = useState(false);

  useEffect(() => {
    if (width < 650) {
      _axios
        .get(buildLink("all_categories", undefined, window.innerWidth))
        .then((response) => {
          setCategories(response.data.data);
        });
    }
  }, []);

  // Logout
  function logout() {
    dispatch({ type: "setLoading", payload: true });
    setViewMenu(false);
    _axios.post(buildLink("logout", undefined, window.innerWidth)).then(() => {
      checkLogin();
    });
    Cookies.remove("api-token");
    window.location.reload();
    history("/");
  }

  function checkLogin() {
    dispatch({ type: "setLoading", payload: true });
    _axios
      .get(buildLink("login", undefined, window.innerWidth))
      .then((response) => {
        const data = response.data;

        dispatch({ type: "setShowOver", payload: false });
        if (data.customer_id > 0) {
          dispatch({ type: "setLoged", payload: true });
          dispatch({ type: "setUsername", payload: data.username });
          dispatch({ type: "setEmail", payload: data.email });
        } else {
          dispatch({ type: "setLoged", payload: false });
        }
        if (data.seller_logged !== "0") {
          setSellerId(Number(data.seller_logged));
        }
        dispatch({ type: "setLoading", payload: false });
      });
  }

  const copy = async () => {
    await navigator.clipboard.writeText(window.location.href);
    setShowMessage(true);
  };

  const remove = () => {
    return setTimeout(() => {
      setShowMessage(false);
    }, 2000);
  };

  function handleScroll() {
    // console.log("entered");
    var myDiv = document.getElementById("scrollDiv");
    myDiv.scrollTop = 0;
  }

  function changeCurrency(currency) {
    Cookies.set("change", true);
    // localStorage.setItem("currency", currency);
    // console.log(currency)
    var obj = {
      currency: currency,
    };
    _axios
      .post(buildLink("currency", undefined, window.innerWidth), obj)
      .then((response) => {
        const data = response.data;
        // alert(data.success)
        if (data.success === true) {
          // localStorage.setItem("currency", currency);
          window.location.reload();
        }
      });
  }

  const changeState = (e) => {
    setshow(true);
  };

  return (
    <div id="headersticky" className="relative headersticky">
       <h1 style={{ position: "absolute", left: "-9999px" }}>Website Works</h1>
      {/* {local && (
        <div
          className={` w-full ${width < 650 && local ? "h-32 p-5" : "h-16"}`}
        >
          <button
            className="bg-dblue text-white font-bold  p-2 m-2"
            onClick={() => localStorage.setItem("site-local-name", "ishtari")}
          >
            ishtari
          </button>

          <button
            className="bg-dblue text-white font-bold  p-2 m-2"
            onClick={() =>
              localStorage.setItem("site-local-name", "ishtari-usd")
            }
          >
            ishtari-usd
          </button>
          <button
            className="bg-dblue text-white font-bold  p-2 m-2"
            onClick={() =>
              localStorage.setItem("site-local-name", "ishtari-ghana")
            }
          >
            ishtari ghana
          </button>
        <button className="bg-dblue text-white font-bold  p-2 m-2" onClick={localStorage.setItem("site-local-name", 'ishtari-usd')} >ishtari Usd</button> 
          <button
            className="bg-dblue text-white font-bold  p-2 m-2"
            onClick={() => localStorage.setItem("site-local-name", "flo")}
          >
            flo-lebanon
          </button>
          <button
            className="bg-dblue text-white font-bold  p-2 m-2"
            onClick={() => localStorage.setItem("site-local-name", "flo-bey")}
          >
            flo-beirut
          </button>

          <button
            className="bg-dblue text-white font-bold  p-2 m-2"
            onClick={() => localStorage.setItem("site-local-name", "aalbeit")}
          >
            aalbeit
          </button>

          <button
            className="bg-dblue text-white font-bold  p-2 m-2"
            onClick={() =>
              localStorage.setItem("site-local-name", "energy-plus")
            }
          >
            Energy+
          </button>
        </div>
      )} */}
      <div
        className={`transition-all min-h-screen w-screen bg-white fixed top-0  bottom-0 right-0 ov/erflow-x-hidden overflow-y-scroll z-50  ${
          viewMenu ? "right-0" : " right-full"
        }`}
        id="scrollDiv"
      >
        {/* Mobile Menu */}
        <div className=" text-dblack overflow-x-hidden">
          {/* Logo */}
          <div className="flex flex-col py-3 border-b border-dgrey px-4 ">
            <div className="flex items-center justify-between">
              {/* <img
                src={Logo}
                alt={window.config["short-name"]}
                className="h-8"
              /> */}

              {localStorage.getItem("site-local-name") === "flo" ||
              window.location.host === "flo-lebanon.com" ? (
                <img
                  src={LogofloOrange}
                  alt={window.config["short-name"]}
                  className="h-8"
                />
              ) : (
                <img
                  src={Logo}
                  alt={window.config["short-name"]}
                  className="h-8"
                />
              )}
              <button onClick={() => setViewMenu(false)}>
                <i className="icon icon-cancel text-2xl"></i>
              </button>
            </div>
            <h2 className=" font-semibold pt-2">
              Hi, We Are {window.config["short-name"]}
            </h2>
          </div>
          <div className="relative">
            {/* Second row */}
            <div className=" relative flex items-center justify-between py-4 px-8 border-b border-dgrey">
              {/* Home */}
              <Link to="/" className="menu-button">
                <span className="menu-icon">
                  <i className="icon icon-home"></i>
                </span>
                <span>Home</span>
              </Link>
              {/* My account */}
              {state.loged && (
                <Link to={`${path}/account/profile`} className="menu-button">
                  <span className="menu-icon">
                    <i className="icon icon-user-solid"></i>
                  </span>
                  <span>Account</span>
                </Link>
              )}
              {/* Logout */}
              {state.loged && (
                <button onClick={() => logout()} className="menu-button">
                  <span className="menu-icon">
                    <i className="icon icon-logout"></i>
                  </span>
                  <span>Log Out</span>
                </button>
              )}
              {/* Sign in */}
              {!state.loged && (
                <button className="menu-button" onClick={() => openAuthForm()}>
                  <span className="menu-icon">
                    <i className="icon icon-user-solid"></i>
                  </span>
                  <span>Sign In</span>
                </button>
              )}
              {/* Sign up */}
              {!state.loged && (
                <button className="menu-button" onClick={() => openAuthForm()}>
                  <span className="menu-icon">
                    <i className="icon icon-user-plus"></i>
                  </span>
                  <span>Sign Up</span>
                </button>
              )}
              {/* Cart */}
              <Link to={`${path}/cart`} className="menu-button">
                <span className="menu-icon">
                  <i className="icon icon-basket"></i>
                </span>
                <span>Basket</span>
              </Link>
            </div>
            {/* Categories */}
            <div className="p-4 overflow-x-hidden">
              {/* Level 2 categories */}
              <div
                className={`absolute w-full h-full min-h-screen right-0 top-0 transition-all bg-white ${
                  viewLevel2 ? "left-0" : "left-full"
                }`}
              >
                <div className="p-4">
                  <div
                    className="flex items-center py-1  "
                    onClick={() => setViewLevel2(false)}
                  >
                    <i className="icon icon-angle-left text-2xl mr-2"></i>
                    <h2
                      className="font-semibold"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(activeCategory.name),
                      }}
                    ></h2>
                  </div>
                  {activeCategory.categories?.length > 0 &&
                    activeCategory?.categories?.map((category) => (
                      <Link
                        to={{
                          pathname: `${
                            // state.admin
                            //   ? path + "/category/" + category.category_id
                            //   :
                            category.name.length > 0
                              ? "/" +
                                category.name
                                  .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                                  .replaceAll("/", "-")
                                  .replace(/\s+/g, "-") +
                                "/c=" +
                                category.category_id
                              : "cat/c=" + category.category_id
                          }`,
                          state: {
                            banner_image_id: "",
                            source_type: "categories",
                            source_type_id: "",
                          },
                        }}
                        className=" flex justify-between  items-center border-b border-dgrey py-1"
                        key={category.name}
                      >
                        <span
                          className="font-light py-1"
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(category.name),
                          }}
                        ></span>
                      </Link>
                    ))}
                </div>
              </div>
              <div
                className={`${window.config["showMenu"] ? "block" : "hidden"}`}
              >
                <h2 className=" text-dgrey1 text-xs mb-2">ALL CATEGORIES</h2>

                {categories?.length > 0 &&
                  categories?.map((category) => (
                    <div
                      className=" flex justify-between items-center border-b border-dgrey py-1"
                      key={category.name}
                    >
                      <Link
                        to={{
                          pathname: `${
                            // state.admin
                            //   ? path + "/category/" + category.category_id
                            //   :
                            category.name.length > 0
                              ? "/" +
                                category.name
                                  .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                                  .replaceAll("/", "-")
                                  .replace(/\s+/g, "-") +
                                "/c=" +
                                category.category_id
                              : "cat/c=" + category.category_id
                          }`,
                          state: {
                            banner_image_id: "",
                            source_type: "categories",
                            source_type_id: "",
                          },
                        }}
                        // to={`${path}/category/${category.category_id}`}
                        className="font-light"
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(category.name),
                        }}
                      ></Link>
                      <span
                        className="w-10 flex items-center justify-center"
                        onClick={() => {
                          setActiveCategory(category);
                          setViewLevel2(true);
                          handleScroll();
                        }}
                      >
                        <i className="icon icon-angle-right text-2xl text-dgrey1"></i>
                      </span>
                    </div>
                  ))}
                <Link
                  to={`${path}/latest`}
                  className=" flex justify-between items-center"
                >
                  <span className="font-semibold py-2 pb-36">NEW ARRIVALS</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        {/* End Mobile Menu */}
      </div>

      <div className>
        {/* Admin Top Bar */}

        <div
          className={
            !state.admin
              ? "hidden"
              : `h-12 px-10 text-white flex items-center ${
                  (localStorage.getItem("site-local-name") === "energy-plus" ||
                    window.location.host === "www.energyplus-lb.com") &&
                  "bg-Energyplus text-dblackk"
                }`
          }
          style={{ background: "#555" }}
        >
          <div className="container flex justify-between  items-center">
            {window.location.pathname !== "/pos" &&
            window.location.pathname !== "/orders" ? (
              <div className="space-x-10 flex ">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={window.config["admin-products-url"] + token}
                >
                  Products
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={window.config["admin-orders-url"] + token}
                >
                  Orders
                </a>
                {(localStorage.getItem("site-local-name") === "flo" ||
                  window.location.host === "www.flo-lebanon.com") &&
                  window.location.href.indexOf("bey") < 0 && (
                    <>
                      {" "}
                      <a target="_blank" rel="noreferrer" href={"/pos"}>
                        Pos
                      </a>
                      <a target="_blank" rel="noreferrer" href={"/orders"}>
                        orders list
                      </a>
                      {!loadingExport && errPermission.length === 0 ? (
                        <div
                          className="cursor-pointer"
                          onClick={() => setExportProduct(true)}
                        >
                          Export PDF
                        </div>
                      ) : !loadingExport && errPermission.length > 0 ? (
                        <div>{errPermission}</div>
                      ) : (
                        <div className="">Loading...</div>
                      )}
                    </>
                  )}

                {(localStorage.getItem("site-local-name") === "flo-bey" ||
                  window.location.href.indexOf("bey") > 0) && (
                  <>
                    {" "}
                    <a target="_blank" rel="noreferrer" href={"/bey/pos"}>
                      Pos
                    </a>
                    <a target="_blank" rel="noreferrer" href={"/bey/orders"}>
                      orders list
                    </a>
                  </>
                )}
              </div>
            ) : (
              <div className="w-full">
                <a rel="noreferrer" classname="font-extrabold" href={"/pos"}>
                  Pos
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  className="float-right"
                  href={"/orders"}
                >
                  orders list
                </a>
              </div>
            )}
            <div> {showMessage && remove() && "Link COPIED"}</div>
            {window.location.pathname !== "/pos" &&
              window.location.pathname !== "/orders" && (
                <div className=" cursor-pointer">
                  <p onClick={copy}>Copy Link</p>
                </div>
              )}
          </div>
        </div>
        <div
          className={`${
            localStorage.getItem("site-local-name") === "flo" ||
            localStorage.getItem("site-local-name") === "flo-bey" ||
            window.location.host === "www.flo-lebanon.com"
              ? "bg-Orangeflo"
              : localStorage.getItem("site-local-name") === "aalbeit" ||
                window.location.host === "www.albeit.com"
              ? "bg-greenaalbeit"
              : width > 650
              ? "bg-dbase"
              : "bg-white"
          } h-16 flex items-center`}
        >
          <div className="p-3 w-full">
            <div className="flex justify-between items-center ">
              <div className="flex  items-center">
                <button onClick={() => setViewMenu(true)}>
                  <i
                    className={`xl:hidden xs:hidden lg:hidden icon icon-menu  text-s  mr-4 ${
                      width < 650 ? "text-dgreyBlack" : "text-white"
                    } `}
                  ></i>
                </button>
                <Link to={`${path}/`}>
                  {localStorage.getItem("site-local-name") === "flo" ||
                  localStorage.getItem("site-local-name") === "flo-bey" ||
                  window.location.host === "www.flo-lebanon.com" ? (
                    <img
                      src={logoflo}
                      className=" h-8 mr-4"
                      alt={window.config["short-name"]}
                    />
                  ) : width > 650 ? (
                    <img
                      src={logo}
                      className="h-8 mr-4"
                      alt={window.config["short-name"]}
                    />
                  ) : (
                    <ImageFilter
                      className="h-5 w-24"
                      image={logo}
                      filter={"duotone"} // see docs beneath
                      colorOne={[96, 96, 96]}
                      colorTwo={[65, 69, 81]}
                    />
                  )}
                </Link>
              </div>

              {(window.config["site-url"] === "https://www.ishtari.com" ||
                window.config["site-url"] === "https://www.ishtari.com.gh") && (
                <div className="flex justify-center ">
                  <div>
                    <div className="dropdown relative float-right lg:pr-2">
                      <button
                        className="
                       hover:-translate-y-1
                    text-white
                          dropdown-toggle
                          px-1
                          text-s
                          leading-tight
                          transition
                          duration-150
                          ease-in-out
                          flex
                          items-center
                          whitespace-nowrap
                        "
                        onClick={() => setInt(!int ? true : false)}
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {window.config["site-url"] ===
                        "https://www.ishtari.com" ? (
                          <div className=" flex  p-1 sm:p-3">
                            <img
                              className="w-7 h-5 "
                              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAhCAYAAACbffiEAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAMrSURBVFhH7VhbSFRRFD1iVBj1I/QVhJMoaQ1mKSaBmJmWaWpgD7KHZlmJWoL0UMtCRSU0ykcPx2cPMsvSKZ/5IiM1K0clMUMkKzXTNAMtXe17vR8JfkhzLgwxCxb3nn3Onrlr1tlnZg8bXGaK/4F6IbpGvRBdo17IXPl1lpgcZP1sPuRiH/GHwRLxOts8T7JfmjbIRXT0QF2uAj4MzDrPkwwy4uXwe7DUVfCqj5ci8kFWIYY528ByiZmbwJLNoSwMwMjET2mWL2QRMjk1BdunYWCqjVA88INrRQQsio6BXVXiaGOatIovZBHS9KUFxnkeONGswkUiS7eDZdFxuFVE4krbfTR/65JW8gN3IUH1SWCXlmN3XSLYtfWwLzuNwIZ0mJAzZgUHYPkoUFrJF1yFJL5SIfxNLlqGuuFUEg6W7QqWRfWR4QCb4mB4VZ4TxbF0W5R8ei1l8QF3R+r7NGBJK8BytkBRsB+OZafofitYnjuJcsbJpgw4lJ9BDG2xofFRKUt7cBXC0qxhku+LSKEuVE5Q0CnFVI642Vk6fXrd8hTdURYHIaQ6BqGN6VKm9uAmRHHXBwMTY/CoisbBugR6YEdywWPaiUxnErEd80jIXmEuZQ2sCg9LmXzA1REHdSi5slZ0I6TxOhbd9sTOqgswEJwgR9wrorBBHYy+8RGsfkzHcYoSLcM9UrZ24CKkc/QzWLQRdtXGI7e7hsTYwO5JKFY+9INFoT8VvVAj5E6qNdXJZqohM4SRUAFdlMsDWgsRCtafjtwpuk/W3AO7bE41kgWXykh6aBdxSwkilubvEdf718TB+9l5eFdGid/2pR8bxLi24OJI2/de+FABx7bmS5FpsBQrsDs7aFu5waPirBSdCWXBPtT1t0ujfwfXGvkbe2rjxE+cpa0THTGkopcTsgjxfR4Ls6IAaURvcsMOZuojsK+OkCL8wa0fmdS0o6/pBRLUSdSH0G+pzl78phhaO6gf6cWQ5i1Vdg8OZQcD77oxMctraENuHaLQBQ4xI4yxxRhgC2bMCeNBtlC8Thoay9Ixcu3Z59Kfy9XD6/9F0TXqhega9UJ0i6b4A/QB3t+zIyKhAAAAAElFTkSuQmCC"
                              alt="Lebanon"
                            />{" "}
                            {width > 650 && (
                              <span className="ml-2"> Lebanon</span>
                            )}
                            <span className="ml-3 hidden mobile:block">
                              {" "}
                              Lebanon
                            </span>
                          </div>
                        ) : (
                          <div className="flex p-1 sm:p-3">
                            <img
                              className="w-7 h-5"
                              src="data:image/png;base64,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"
                              alt="ghana"
                            />{" "}
                            {width > 650 && (
                              <span className="ml-2"> Ghana</span>
                            )}
                          </div>
                        )}{" "}
                        <FiChevronDown
                          className={`icon icon-down-dir transition-all text-dblackk ${
                            width > 650 && "text-white"
                          }  mobile:block ${int && "transform rotate-180"}`}
                        ></FiChevronDown>
                      </button>
                      {int ? (
                        <ul className="dropdown-menu min-w-max absolute right-0 bg-white text-base z-[999] float-left py-3 px-3 list-none text-left rounded-sm shadow-lg">
                          <li>
                            <a
                              className="flex py-3 pl-2 pr-3 hover:bg-dgrey1 hover:bg-opacity-10 hover:text-dbase"
                              href="https://www.ishtari.com"
                            >
                              {" "}
                              <img
                                className="w-7 h-5"
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAhCAYAAACbffiEAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAMrSURBVFhH7VhbSFRRFD1iVBj1I/QVhJMoaQ1mKSaBmJmWaWpgD7KHZlmJWoL0UMtCRSU0ykcPx2cPMsvSKZ/5IiM1K0clMUMkKzXTNAMtXe17vR8JfkhzLgwxCxb3nn3Onrlr1tlnZg8bXGaK/4F6IbpGvRBdo17IXPl1lpgcZP1sPuRiH/GHwRLxOts8T7JfmjbIRXT0QF2uAj4MzDrPkwwy4uXwe7DUVfCqj5ci8kFWIYY528ByiZmbwJLNoSwMwMjET2mWL2QRMjk1BdunYWCqjVA88INrRQQsio6BXVXiaGOatIovZBHS9KUFxnkeONGswkUiS7eDZdFxuFVE4krbfTR/65JW8gN3IUH1SWCXlmN3XSLYtfWwLzuNwIZ0mJAzZgUHYPkoUFrJF1yFJL5SIfxNLlqGuuFUEg6W7QqWRfWR4QCb4mB4VZ4TxbF0W5R8ei1l8QF3R+r7NGBJK8BytkBRsB+OZafofitYnjuJcsbJpgw4lJ9BDG2xofFRKUt7cBXC0qxhku+LSKEuVE5Q0CnFVI642Vk6fXrd8hTdURYHIaQ6BqGN6VKm9uAmRHHXBwMTY/CoisbBugR6YEdywWPaiUxnErEd80jIXmEuZQ2sCg9LmXzA1REHdSi5slZ0I6TxOhbd9sTOqgswEJwgR9wrorBBHYy+8RGsfkzHcYoSLcM9UrZ24CKkc/QzWLQRdtXGI7e7hsTYwO5JKFY+9INFoT8VvVAj5E6qNdXJZqohM4SRUAFdlMsDWgsRCtafjtwpuk/W3AO7bE41kgWXykh6aBdxSwkilubvEdf718TB+9l5eFdGid/2pR8bxLi24OJI2/de+FABx7bmS5FpsBQrsDs7aFu5waPirBSdCWXBPtT1t0ujfwfXGvkbe2rjxE+cpa0THTGkopcTsgjxfR4Ls6IAaURvcsMOZuojsK+OkCL8wa0fmdS0o6/pBRLUSdSH0G+pzl78phhaO6gf6cWQ5i1Vdg8OZQcD77oxMctraENuHaLQBQ4xI4yxxRhgC2bMCeNBtlC8Thoay9Ixcu3Z59Kfy9XD6/9F0TXqhega9UJ0i6b4A/QB3t+zIyKhAAAAAElFTkSuQmCC"
                                alt="Lebanon"
                              />{" "}
                              {/* <span className="ml-2 mr-2"> Lebanon</span> */}
                              <span class="ml-2 mr-2 transition-all duration-300 ease-in-out ">
                                Lebanon
                              </span>
                            </a>
                          </li>
                          <li>
                            <a
                              className="flex py-3 pl-2 pr-3 hover:bg-dgrey1 hover:bg-opacity-10 hover:text-dbase"
                              href="https://www.ishtari.com.gh"
                            >
                              <img
                                className="w-7 h-5"
                                src="data:image/png;base64,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"
                                alt="ghana"
                              />{" "}
                              <span className="ml-2 mr-2 transition-all duration-300 ease-in-out ">
                                {" "}
                                Ghana
                              </span>
                            </a>
                          </li>
                        </ul>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* currency here */}
              {currency?.data?.allow_change_currency_in_website === "true" &&
                currency?.data?.allow_change_currency_in_checkout ===
                  "false" && (
                  <div className="flex justify-center ">
                    <div>
                      {window.config["site-url"] ===
                        "https://www.ishtari.com" ||
                      window.config["site-url"] ===
                        "https://www.flo-lebanon.com" ||
                      window.config["site-url"] === "https://www.aalbeit.com" ||
                      window.config["site-url"] ===
                        "https://www.energyPlus-lb.com" ? (
                        <div className="dropdown relative ml-1 mr-3">
                          <button
                            className="dropdown-toggle
                            px-1
                            py-2.5
                            text-dgreyBlack
                            sm:text-white
                            text-s
                            leading-tight
                            transition
                            duration-150
                            ease-in-out
                            flex
                            items-center
                            whitespace-nowrap"
                            onClick={() => setCurr(!curr ? true : false)}
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {localStorage.getItem("currency") === "USD" ? (
                              width > 650 ? (
                                <span>USD</span>
                              ) : (
                                <span className="font-semibold text-xl">$</span>
                              )
                            ) : localStorage.getItem("currency") === "LBP" ? (
                              width > 650 ? (
                                <span>LBP</span>
                              ) : (
                                <span className="font-semibold text-xl">
                                  L.L.
                                </span>
                              )
                            ) : width > 650 ? (
                              <span>USD</span>
                            ) : (
                              <span className="font-semibold text-xl">$</span>
                            )}

                            {width > 650 && (
                              <svg
                                aria-hidden="true"
                                focusable="false"
                                data-prefix="fas"
                                data-icon="caret-down"
                                className="w-2 ml-1"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 320 512"
                              >
                                <path
                                  fill="currentColor"
                                  d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                                ></path>
                              </svg>
                            )}
                          </button>
                          {curr ? (
                            <ul className="dropdown-menu min-w-max absolute top bg-white text-base z-50 float-left p-2 list-none text-left rounded-lg shadow-lg">
                              <li>
                                <div
                                  className="flex items-center py-3 pl-2 pr-3 cursor-pointer"
                                  onClick={() => changeCurrency("USD")}
                                >
                                  {" "}
                                  <span className="ml-2 mr-2"> $ USD</span>
                                </div>
                              </li>
                              <li>
                                <div
                                  className="flex py-3 pl-2 pr-3 cursor-pointer"
                                  onClick={() => changeCurrency("LBP")}
                                >
                                  <span className="ml-2 mr-2"> L.L. LBP</span>
                                </div>
                              </li>
                            </ul>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : window.config["site-url"] ===
                        "https://www.ishtari.com.gh" ? (
                        <div className="dropdown relative ml-1 mr-3">
                          <button
                            className="dropdown-toggle
                            px-1
                            py-2.5
                            text-white
                            text-s
                            leading-tight
                            transition
                            duration-150
                            ease-in-out
                            flex
                            items-center
                            whitespace-nowrap"
                            onClick={() => setCurr(!curr ? true : false)}
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {localStorage.getItem("currency") === "USD" ? (
                              <span>USD</span>
                            ) : localStorage.getItem("currency") === "GHS" ? (
                              <span>GH¢</span>
                            ) : (
                              <span>GH¢</span>
                            )}

                            {width > 650 && (
                              <svg
                                aria-hidden="true"
                                focusable="false"
                                data-prefix="fas"
                                data-icon="caret-down"
                                className="w-2 ml-1"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 320 512"
                              >
                                <path
                                  fill="currentColor"
                                  d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                                ></path>
                              </svg>
                            )}
                          </button>
                          {curr ? (
                            <ul className="dropdown-menu min-w-max absolute top bg-white text-base z-50 float-left p-2 list-none text-left rounded-lg shadow-lg">
                              <li>
                                <div
                                  className="flex items-center py-3 pl-2 pr-3 cursor-pointer"
                                  onClick={() => changeCurrency("GHS")}
                                >
                                  {" "}
                                  <span className="ml-2 mr-2"> GHS </span>
                                </div>
                              </li>
                              <li>
                                <div
                                  className="flex py-3 pl-2 pr-3 cursor-pointer"
                                  onClick={() => changeCurrency("USD")}
                                >
                                  <span className="ml-2 mr-2"> USD </span>
                                </div>
                              </li>
                            </ul>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                )}

              <div className="flex items-center flex-grow justify-end">
                <Suspense fallback={<div></div>}>
                  <TopSearch changeState={changeState} />
                </Suspense>
                {state.isSeller && (
                  <div>
                    <a
                      className="hidden md:block mx-2 text-white font-bold"
                      // href={`https://www.ishtari.com/index.php?route=seller_report/kt_dashboard&sid=${sellerId}`}
                      href={`https://www.ishtari.com/seller_report/home`}
                    >
                      SELLER DASHBOARD
                    </a>
                  </div>
                )}
                <Suspense fallback={<div></div>}>
                  <TopAccountTest />
                </Suspense>
      {state.loged && <TopWishlist />}
                <Suspense fallback={<div></div>}>
                  <TopCart />
                </Suspense>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Menu */}
      {/* <Suspense fallback={<div></div>}> */}
      <div
        className="w-screen"
        style={{
          borderBottom: "1px solid rgb(226, 229, 241)",
          backgroundColor: "rgb(252 244 244)",
        }}
      >
        {window.location.pathname !== "/pos" &&
          window.location.pathname !== "/orders" && <DesktopMenu />}
      </div>
      {/* </Suspense> */}
      {/* <div className="border-8 border-dinputBorder bg-dinputBorder"></div>  */}
      {show && (
        <div className="absolute z-10 bg-dblack w-screen h-screen -mt-12 opacity-70"></div>
      )}
      {state.length > 0 && width > 600 && (
        <DesktopMenu
          header_categories={state}
          local={local}
          headerSettings={headerSettings}
        />
      )}
    </div>
  );
}

export default TopHeader;
